import React, { useRef, useState } from "react";
import ErrorMessage from "../../../../../Shared/error-message/errorMessage";
import Styles from "../../Shared/sharedStyles.module.scss";
import InputField from "../../Shared/inputField/inputField";
import {
  buttonStyles,
  StyledButton,
} from "../../../../../Shared/button/button";
import { validUdyogAadhaarNumber } from "../../../../../utils/validation";
import { IdsGenerator } from "../../../../../utils/idGenerator";

function UdyogServicePopup({ handleResponse }: any) {
  const errorObject = {
    udyogAadhaarNumberError: false,
    consentError: false,
  };

  const [error, setError] = useState({ ...errorObject });
  const [isChecked, setIsChecked] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [loading, setLoading] = useState(false);

  const udyogAadhaarNumberRef = useRef<any>("");

  function isValid() {
    if (
      validUdyogAadhaarNumber(
        udyogAadhaarNumberRef.current.value.trim().toUpperCase()
      )
    ) {
      setError(errorObject);
      return setIsDisabled(false);
    }
    setError(() => ({
      ...error,
      udyogAadhaarNumberError: true,
    }));
    return setIsDisabled(true);
  }

  function handleCheck() {
    const udyogAadhaarNumber =
      udyogAadhaarNumberRef.current.value.toUpperCase();
    const consent = isChecked === true ? "Y" : "N";

    if (!validUdyogAadhaarNumber(udyogAadhaarNumber)) {
      setError(() => ({
        ...error,
        udyogAadhaarNumberError: true,
      }));
      return false;
    } else if (!isChecked) {
      setError(() => ({
        ...error,
        consentError: true,
      }));
      return false;
    }
    setLoading(true);
    handleResponse({ udyogAadhaarNumber, consent }, setLoading);
  }
  return (
    <div className={`${Styles.content}`}>
      <div className={`${Styles.infoForm} pl-2`}>
        <hr />
        <p className="mt-2">Fill in the below details to run verification</p>
        <div className="d-flex flex-column">
          <div className="d-flex flex-column mb-4 ">
            <label className={`${Styles.label} flex-grow-1`}>
              Udyog Aadhaar Number
            </label>
            <InputField
              id={IdsGenerator({
                prefix: "Udyog Aadhaar popup",
                id: "change",
                suffix: "Aadhaar number",
              })}
              onChange={isValid}
              maxLength={19}
              inputRef={udyogAadhaarNumberRef}
              isError={error.udyogAadhaarNumberError}
              purpose="forPan"
            />
            {error.udyogAadhaarNumberError && (
              <ErrorMessage>
                Please enter a valid Udyog Aadhaar number
              </ErrorMessage>
            )}
          </div>
          <div className="pt-4 pl-4 pb-4 mt-4 d-flex flex-column">
            <div className="d-flex align-items-center py-0 gap-2">
              <input
                id={IdsGenerator({
                  prefix: "Udyog Aadhaar popup",
                  id: "check",
                  suffix: "consent",
                })}
                data-testid={IdsGenerator({
                  prefix: "Udyog Aadhaar popup",
                  id: "check",
                  suffix: "consent",
                })}
                type="checkbox"
                className={`${Styles.formCheckInput} `}
                onChange={(e: any) => {
                  setIsChecked(e.target.checked);
                  isValid();
                }}
              />
              <p className={`${Styles.ackText} mb-0`}>
                I hereby agree, to let zoop.one verify my data for verification
              </p>
            </div>
            {error.consentError && (
              <ErrorMessage>Please provide consent!</ErrorMessage>
            )}
          </div>
          <div className={`${Styles.buttonGroup}`}>
            <StyledButton
              id={IdsGenerator({
                prefix: "Udyog Aadhaar popup",
                id: "click",
                suffix: "run verification",
              })}
              hoverStyle={{ ...buttonStyles.primary.hover }}
              disabled={isDisabled}
              isLoading={loading}
              style={{ ...buttonStyles.primary.normal }}
              onClick={() => {
                setTimeout(() => setError({ ...errorObject }), 2000);
                handleCheck();
              }}
            >
              Run Verification
            </StyledButton>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UdyogServicePopup;
